<template>
    <component
        :is="assignComponent()"
        :to="routerLink"
        :exact="exact"
        :class="{
            'uik-nav-link__wrapper': true,
            'active': active
        }"
        :replace="replace"
    >
        <span class="uik-nav-link__text">
            <span v-if="icon != ''" class="uik-nav-link__icon">{{ icon }}</span>
            <slot></slot>
        </span>
        <span v-if="rightEl != ''" class="uik-nav-link__rightEl">
            {{ rightEl }}
        </span>
    </component>
</template>

<script>
export default {
    name: "UikNavLink",
    props: {
        component: { type: String, default: "a" },
        routerLink: { type: String, default: "" },
        active: { type: Boolean, default: false },
        rightEl: { type: String, default: "" },
        icon: { type: String, default: "" },
        exact: { type: Boolean, default: false },
        replace: { type: Boolean, default: false }
    },
    methods: {
        assignComponent () {
            if (this.routerLink !== "") {
                return "router-link"
            }
            return "a"
        }
    }
}
</script>

<style lang="scss">
.uik-nav-link__wrapper {
  font-size: .875rem;
  color: $textMain;
  display: block;
  padding: 0 30px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .uik-nav-link__icon {
    display: inline-block;
    margin-right: 12px;
    width: 18px;
    text-align: center;
  }
  .uik-nav-link__rightEl {
    font-size: 0.75rem;
    color: $textSecondary;
    line-height: 1rem;
  }
  &.uik-nav-link__highlighted {
    .uik-nav-link__text{
      font-weight: 500;
    }
  }
  // active
  &:global(.active) {
    font-weight: 500;
    color: $primary;
    background: rgba($primary, 0.5);
    box-shadow: inset 3px 0 0 0 $primary;
  }
  &:hover {
    color: white;
    background: $primary;
  }
  &:active {
    background: rgba($primary, 0.5);
  }
}
</style>
